import React, { useState, useEffect, useMemo } from 'react';
import { useRaces } from '../../../hooks/useRaces';
import en from '../../../locales/en.json';
import mk from '../../../locales/mk.json';
import al from '../../../locales/al.json';
import ResultsListPageView from './resultslistpage.view';

const localeMap = { en, mk, al };

function getInitialLang(): 'en' | 'mk' | 'al' {
  const stored = localStorage.getItem('lang');
  if (stored === 'en' || stored === 'mk' || stored === 'al') return stored;
  return 'mk';
}

export default function ResultsListPage() {
  const [lang, setLang] = useState(getInitialLang());
  const t = localeMap[lang];

  useEffect(() => {
    localStorage.setItem('lang', lang);
  }, [lang]);

  const { data: races = [], isLoading: loading } = useRaces();

  const rr: Record<string, any> = (t as any).rr || {};

  const { seriesGroups, standaloneRaces } = useMemo(() => {
    const seriesMap = new Map<number, { name: string; races: any[] }>();
    const standalone: any[] = [];
    for (const race of races) {
      if ((race as any).raceSeriesId && (race as any).raceSeries) {
        if (!seriesMap.has((race as any).raceSeriesId)) {
          seriesMap.set((race as any).raceSeriesId, { name: (race as any).raceSeries.name, races: [] });
        }
        seriesMap.get((race as any).raceSeriesId)!.races.push(race);
      } else {
        standalone.push(race);
      }
    }
    Array.from(seriesMap.values()).forEach(group => {
      group.races.sort((a: any, b: any) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime());
    });
    return { seriesGroups: Array.from(seriesMap.values()), standaloneRaces: standalone };
  }, [races]);

  return (
    <ResultsListPageView
      lang={lang}
      setLang={setLang}
      t={t}
      rr={rr}
      loading={loading}
      racesExist={races.length > 0}
      seriesGroups={seriesGroups}
      standaloneRaces={standaloneRaces}
    />
  );
}
